import React from "react";
import Select from "react-select";
import { TIME_SLOT_OPTIONS } from "./common";

const timeToMinutes = (t) => {
  if (!t) return -1;
  const match = t.match(/^(\d+):(\d+)\s*(AM|PM)$/i);
  if (!match) return -1;
  let hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const period = match[3].toUpperCase();
  if (period === "PM" && hours !== 12) hours += 12;
  if (period === "AM" && hours === 12) hours = 0;
  return hours * 60 + minutes;
};

/**
 * Reusable time slot dropdown (30-min intervals, 9 AM – 8 PM).
 *
 * Props:
 *   value        - currently selected time string (e.g. "9:30 AM")
 *   onChange      - callback receiving the selected time string
 *   placeholder   - placeholder text (default "Select Time")
 *   label         - optional label text
 *   required      - show red asterisk
 *   disabled      - disable the select
 *   startTime     - optional: if set, only show slots >= this time
 *   endTime       - optional: if set, only show slots <= this time
 *   disableBefore - optional: if set, slots < this time are shown but disabled
 */
const TimeSlotSelect = ({
  value,
  onChange,
  placeholder = "Select Time",
  label,
  required = false,
  disabled = false,
  startTime,
  endTime,
  disableBefore,
}) => {
  const startMin = timeToMinutes(startTime);
  const endMin = timeToMinutes(endTime);
  const disableBeforeMin = timeToMinutes(disableBefore);

  const options = TIME_SLOT_OPTIONS.filter((opt) => {
    const optMin = timeToMinutes(opt.value);
    if (startMin >= 0 && endMin >= 0) return optMin >= startMin && optMin <= endMin;
    if (startMin >= 0) return optMin >= startMin;
    if (endMin >= 0) return optMin <= endMin;
    return true;
  }).map((opt) => ({
    ...opt,
    isDisabled: disableBeforeMin >= 0 ? timeToMinutes(opt.value) < disableBeforeMin : false,
  }));

  const selected = value ? { value, label: value } : null;

  return (
    <div>
      {label && (
        <label style={{ fontWeight: 600, fontSize: "14px", color: "black", display: "block", marginBottom: "4px" }}>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}
      <Select
        placeholder={placeholder}
        value={selected}
        options={options}
        isDisabled={disabled}
        onChange={(e) => onChange(e?.value || "")}
      />
    </div>
  );
};

export default TimeSlotSelect;
